import { IState, IUploadingFile } from '@interfaces';

export const dmcaFilesSelector = (state: IState): IUploadingFile[] => Object.values(state.dmca.files);

export const dmcaFormSelector = (state: IState) => state.dmca.form;
